// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"d6384da7","177":"b54a0729","223":"f408f7c6","787":"545aecf5"}[chunkId] + ".chunk.js";
};